<template>
    <div class="" style="">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">通知公告</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="trpa_listContent">
        <div class="e-flex trpa_listFlexContent" v-for="(item, index) in list"  v-if="index % 2 == 0">
            <div class="trpa_listBlock" @click="goDetail(item.id)">
                <div class="trpa_listBlockText e-line-1">{{ item.title }}</div>
                <div class="trpa_listBlockDate">{{ item.publishDate.slice(0,10) }}</div>
            </div>
            <div class="trpa_listBlock trpa_listBlockLeft" v-if="list[index + 1]" @click="goDetail(list[index + 1].id)">
                <div class="trpa_listBlockText e-line-1">{{ list[index + 1].title }}</div>
                <div class="trpa_listBlockDate">{{ list[index + 1].publishDate.slice(0,10) }}</div>
            </div>
            <div v-else class="trpa_listBlockNodata trpa_listBlockLeft"></div>
        </div>
      </div>
      <div class="e-flex trp_paginationContent">
            <el-pagination background layout="prev, pager, next, jumper" :page-size="10" :total="total" @current-change="pageChange"></el-pagination>
        </div>
    </div>
  </template>
  
  <script>
    import '../../styles/twoRegionPolicy.css'
    export default {
      name: 'twoRegionPolicy',
      data () {
        return {
            list: [],
            page: 1,
            total: 1
        }
      },
      created() {
        this.getData()
      },
      methods: {
        pageChange(e) {
            this.page = e
            this.getData()
        },
        goDetail(id) {
            this.$router.push({ path: '/twoRegionPolicy/twoRegionPolicyAnnouncementDetail', query: {id: id}})
        },
        getData() {
            this.request({
                url: 'notice/list?page=' + this.page + '&limit=100',
                method: 'get',
                data: {}
            }).then(res => {
                this.total = res.recordsTotal
                this.list = res.data
            })
        }
      }
    }
  </script>

  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/twoRegionPolicy/twoRegionPolicyAnnouncement.vue